import { products } from "@/mocks/site-data";

export default function Produtos() {
  const featuredProduct = products.find((p) => p.id === "ie");
  const otherProducts = products.filter((p) => p.id !== "ie");

  return (
    <main className="pt-20 md:pt-24">
      <section className="py-16 md:py-24 bg-background-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="text-center mb-14 md:mb-20 max-w-3xl mx-auto">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
              Nossas Soluções
            </span>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 font-heading mb-4">
              Produtos REDENET
            </h1>
            <div className="w-16 h-1 bg-accent-500 mx-auto rounded-full mb-5" />
            <p className="text-foreground-600 text-base md:text-lg">
              Conheça nossos sistemas desenvolvidos para transformar a educação brasileira. Em 2027 o iEscolar Online será atualizado para a nova versão IE — Gestão Educacional Integrada.
            </p>
          </div>

          <div className="max-w-5xl mx-auto space-y-8 md:space-y-12">
            {/* Featured IE Product */}
            {featuredProduct && (
              <div className="bg-background-50 border border-accent-400 rounded-xl p-6 md:p-10 relative ring-1 ring-accent-300">
                <span className="absolute -top-3 left-6 md:left-10 px-4 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs font-bold shadow-sm">
                  {featuredProduct.badge}
                </span>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
                  <div>
                    <div className="flex items-center gap-4 mb-5">
                      <img
                        src={featuredProduct.logo}
                        alt={featuredProduct.name}
                        className="h-20 w-20 object-contain rounded-lg"
                      />
                      <div>
                        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                          {featuredProduct.name}
                        </h2>
                        <p className="text-sm text-accent-600 font-medium mt-0.5">
                          {featuredProduct.subtitle}
                        </p>
                      </div>
                    </div>
                    <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-5">
                      {featuredProduct.description}
                    </p>
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-semibold mb-5">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-up-line" />
                      </div>
                      Nova versão do iEscolar Online
                    </div>
                    <a
                      href={featuredProduct.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-colors"
                    >
                      Acessar site
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line" />
                      </div>
                    </a>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wide mb-5">
                      Principais Funcionalidades
                    </h3>
                    <ul className="flex flex-col gap-3">
                      {featuredProduct.features.map((feature) => (
                        <li key={feature} className="flex items-start gap-3">
                          <div className="w-6 h-6 rounded-full bg-accent-50 border border-accent-200 flex items-center justify-center shrink-0 mt-0.5">
                            <i className="ri-check-line text-accent-600 text-xs" />
                          </div>
                          <span className="text-sm text-foreground-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* Other Products */}
            <div className="flex flex-col gap-8 md:gap-12">
              {otherProducts.map((product, index) => (
                <div
                  key={product.id}
                  className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center"
                >
                  <div className={index % 2 === 1 ? "md:order-2" : ""}>
                    <div className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-8 relative">
                      {product.badge && (
                        <span className="absolute -top-3 right-6 px-3 py-1 rounded-full bg-secondary-500 text-background-50 text-xs font-bold shadow-sm">
                          {product.badge}
                        </span>
                      )}
                      <div className="flex items-center gap-4 mb-5">
                        {product.logo ? (
                          <img
                            src={product.logo}
                            alt={product.name}
                            className="h-16 w-16 object-contain rounded-lg"
                          />
                        ) : (
                          <div className="w-16 h-16 rounded-lg bg-primary-50 border border-primary-200 flex items-center justify-center">
                            <div className="w-8 h-8 flex items-center justify-center">
                              <i className={`ri-${product.id === "rface" ? "scan-line" : product.id === "iluminia" ? "lightbulb-line" : "bar-chart-2-line"} text-primary-600 text-2xl`} />
                            </div>
                          </div>
                        )}
                        <div>
                          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                            {product.name}
                          </h2>
                          <p className="text-sm text-accent-600 font-medium">
                            {product.subtitle}
                          </p>
                        </div>
                      </div>
                      <p className="text-sm md:text-base leading-relaxed text-foreground-600 mb-6">
                        {product.description}
                      </p>
                      <a
                        href={product.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-colors"
                      >
                        Acessar site
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-arrow-right-line" />
                        </div>
                      </a>
                    </div>
                  </div>

                  <div className={index % 2 === 1 ? "md:order-1" : ""}>
                    <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wide mb-5">
                      Principais Funcionalidades
                    </h3>
                    <ul className="flex flex-col gap-3">
                      {product.features.map((feature) => (
                        <li key={feature} className="flex items-start gap-3">
                          <div className="w-6 h-6 rounded-full bg-accent-50 border border-accent-200 flex items-center justify-center shrink-0 mt-0.5">
                            <i className="ri-check-line text-accent-600 text-xs" />
                          </div>
                          <span className="text-sm text-foreground-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}